import { BusEvents } from "@/core/app/types";
import { EventBus } from 'quasar';

/**
 * Event Bus для клиента и сервера
 * 
 * На сервере (SSR) используются заглушки для предотвращения:
 * - Утечек памяти
 * - Накопления слушателей между запросами
 * - Побочных эффектов
 */

// Заглушка для SSR - не делает ничего
class ServerEventBusStub {
    on() { return this; }
    once() { return this; }
    emit() { return this; }
    off() { return this; }
    clear() { return this; }
}

//@ts-ignore
export const bus: EventBus<BusEvents> = process.env.SERVER 
    ? new ServerEventBusStub() as any
    : new EventBus<BusEvents>();


